var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"login-menu-button",class:{
		'login-menu-button--logged-in': _setup.isLoggedIn,
		'login-menu-button--loading': _setup.loginProgress,
	},style:({ 'pointer-events': _setup.loading ? 'none' : 'auto' }),on:{"click":function($event){return _setup.handleLoginClick()}}},[_c('button',{staticClass:"login-menu-button__button",class:{ 'login-menu-button__button--logged-in': _setup.isLoggedIn || _setup.loginProgress }},[(!_setup.loginProgress)?_c('FontAwesomeIcon',{attrs:{"icon":"user-cog"}}):_c('ion-spinner')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }